export default __webpack_public_path__ + "static/media/gestational_diabetes1.6ed7749a.jpg";